import React from 'react';

const TerminalWindow = ({ title = 'root@arapbett:~$', children, className = '' }) => {
  return (
    <div className={`terminal-window ${className}`}>
      <div className="terminal-header">
        <div className="terminal-dot bg-cyber-red"></div>
        <div className="terminal-dot bg-cyber-amber"></div>
        <div className="terminal-dot bg-cyber-green"></div>
        <span className="ml-3 text-xs text-cyber-muted font-mono">{title}</span>
      </div>
      <div className="terminal-body">
        {children}
      </div>
    </div>
  );
};

export default TerminalWindow;
